import type { TFeatureFlagKey } from '~/constants/types/featureFlags'
import { useFeatureFlagsStore } from '~/stores/FeatureFlagsStore'

/**
 * Composable for managing feature flag access.
 * Provides a stable API for checking feature flags while allowing the underlying
 * implementation to evolve (e.g. store mocking, backend validation).
 */

export function useFeatureFlags() {
  const store = useFeatureFlagsStore()

  const isFeatureEnabled = (flagKey: TFeatureFlagKey): boolean => {
    return store.isFeatureEnabled(flagKey)
  }

  return { isFeatureEnabled }
}
